/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import EventBusService, { VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT } from 'cio/services/event-bus';

interface BranchDeleteButtonArgs {
  actionAbstract: any;
  startBulkDelete: (initiationType: string) => unknown;
  isDisabled: boolean;
}

export default class BranchDeleteButton extends Component<BranchDeleteButtonArgs> {
  @service eventBus!: EventBusService;

  @tracked isShowingWarningModal = false;

  constructor(owner: unknown, args: BranchDeleteButtonArgs) {
    super(owner, args);

    this.eventBus.subscribe(VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT, this, this.onInitiateDeleteFromEvent);
  }

  willDestroy() {
    super.willDestroy();

    this.eventBus.unsubscribe(VWB_INITIATE_SINGLE_DELETE_FROM_KEYBOARD_SHORTCUT, this, this.onInitiateDeleteFromEvent);
  }

  @action
  onInitiateDeleteFromEvent() {
    if (this.args.isDisabled || !this.args.actionAbstract.canDelete) {
      return;
    }

    this.args.startBulkDelete('keyboard');
  }
}
